/* eslint-disable @typescript-eslint/no-use-before-define */
import React, {
	ReactElement,
	useState,
	useContext,
	useEffect,
	ChangeEvent,
	useRef,
	useCallback,
} from "react"
import { useFormik } from "formik"
import {
	Button,
	Box,
	Grid,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from "@material-ui/core"
import { useHistory } from "react-router-dom"
import {
	BaseCFCStruct,
	SpratType,
	KomunikacijaType,
} from "../../../data/_config/shape"
import { initialValues } from "."
import { KomunikacijaTypeSelect, PanelsTitle, SpratTypeSelect } from "../../CFC"
import Spacer from "../../Spacer/Spacer"
import { routeVarReplacement, PrivateRoutes } from "../../../util/routes/routes"
import useCurrentClient from "../../../state/client/useCurrentClient"
import useStyles from "./__config/styles"
import SectionTitle from "../../SectionTitle"
import onCreate from "./onCreate"
import { useParams } from "react-router-dom"
import CFCUseCase from "../../../data/CFC/CFCLogic"
import formatNumberZero from "../../../util/formatNumberZore"
import CFCContext from "../../../state/CFC/context"

/**
 * Create canvas form.
 *
 * @export
 * @returns {ReactElement}
 */
export default function Step2Form({
	osveziMaster,
	values,
}: {
	osveziMaster: (values: any) => void
	values: any
}): ReactElement {
	const styles = useStyles()
	const { id: canvasId } = useParams<any>()

	const [useCustomTitle, setUseCustomTitle] = useState(false)
	const history = useHistory()
	const [currentClient] = useCurrentClient()

	const {
		setFieldValue,
		handleChange,
		// values,
		// setValues,
		handleSubmit,
	} = useFormik<BaseCFCStruct>({
		initialValues,
		onSubmit: async (formValues: BaseCFCStruct) => {},
	})

	const { step2Items } = values

	const [komunikacijaType, setKomunikacijaType] = useState(
		step2Items ? step2Items.komunikacijaType : ("R" as KomunikacijaType)
	)

	const [spratType, setSpratType] = useState(
		step2Items ? step2Items.spratType : ("1" as SpratType)
	)
	const [cenaLiftaKlackalice, setCenaLiftaKlackalice] = useState(0)

	const { step1Items, step1CalculatedData } = values

	let zauzetostPodzemno =
		step1Items && step1Items[0]
			? (+step1Items[0].Vrednost * +step1Items[1].Vrednost) / 100
			: undefined //340
	if (spratType == "0") {
		zauzetostPodzemno = 0
	}

	const sirinaParcele = step1Items && step1Items[4].Vrednost
	const pribliznaDuzinaParcele = parseFloat(
		step1CalculatedData && step1CalculatedData[11][1]
	)

	const povrsinaRampa = 40
	const povrsinaLift = 35
	const povrsinaRampaKlackalica = 30
	const povrsinaLisftKlackalica = 25

	const ukupnoNadzemnoNeto =
		step1CalculatedData && step1CalculatedData[8]
			? step1CalculatedData[8][2]
			: undefined //1023.9

	const cenaAutoLifta1 = 35000
	const cenaAutoLifta2 = 40000
	const cenaAutoLifta3 = 45000

	const cenaKlackalica1 = 48000
	const cenaKlackalica2 = 96000
	const cenaKlackalica3 = 144000

	const trosakPoBrutoPovrsiniPodzemno = 800
	const cenaJedneKlackaliceZa2Auta = 8000

	const cenaIzgradnjeJednePodzemneEtaze =
		zauzetostPodzemno * trosakPoBrutoPovrsiniPodzemno

	const [parkingMestaItems, setParkingMestaItems] = useState<any[]>([
		{
			id: "1",
			sprat: 1,
			R: Math.ceil(zauzetostPodzemno / povrsinaRampa),
			L: Math.ceil(zauzetostPodzemno / povrsinaLift),
			RK: Math.ceil(zauzetostPodzemno / povrsinaRampaKlackalica),
			LK: Math.ceil(zauzetostPodzemno / povrsinaLisftKlackalica),
		},
		{
			id: "2",
			sprat: 2,
			R: Math.ceil(zauzetostPodzemno / povrsinaRampa) * 2,
			L: Math.ceil(zauzetostPodzemno / povrsinaLift) * 2,
			RK: Math.ceil(zauzetostPodzemno / povrsinaRampaKlackalica) * 2,
			LK: Math.ceil(zauzetostPodzemno / povrsinaLisftKlackalica) * 2,
		},
		{
			id: "3",
			sprat: 3,
			R: Math.ceil(zauzetostPodzemno / povrsinaRampa) * 3,
			L: Math.ceil(zauzetostPodzemno / povrsinaLift) * 3,
			RK: Math.ceil(zauzetostPodzemno / povrsinaRampaKlackalica) * 3,
			LK: Math.ceil(zauzetostPodzemno / povrsinaLisftKlackalica) * 3,
		},
		{
			id: "0",
			sprat: 0,
			R: 0,
			L: 0,
			RK: 0,
			LK: 0,
		},
	])

	const [povrsinaStanaItems, setPovrsinaStanaItems] = useState<any[]>([
		{
			id: "1",
			sprat: 1,
			R:
				Math.ceil(
					(ukupnoNadzemnoNeto / (spratType == 0 ? 1 : parkingMestaItems[0].R)) *
						10
				) / 10,
			L:
				Math.ceil(
					(ukupnoNadzemnoNeto / (spratType == 0 ? 1 : parkingMestaItems[0].L)) *
						10
				) / 10,
			RK:
				Math.ceil(
					(ukupnoNadzemnoNeto /
						(spratType == 0 ? 1 : parkingMestaItems[0].RK)) *
						10
				) / 10,
			LK:
				Math.ceil(
					(ukupnoNadzemnoNeto /
						(spratType == 0 ? 1 : parkingMestaItems[0].LK)) *
						10
				) / 10,
		},
		{
			id: "2",
			sprat: 2,
			R:
				Math.ceil(
					(ukupnoNadzemnoNeto / (spratType == 0 ? 1 : parkingMestaItems[1].R)) *
						10
				) / 10,
			L:
				Math.ceil(
					(ukupnoNadzemnoNeto / (spratType == 0 ? 1 : parkingMestaItems[1].L)) *
						10
				) / 10,
			RK:
				Math.ceil(
					(ukupnoNadzemnoNeto /
						(spratType == 0 ? 1 : parkingMestaItems[1].RK)) *
						10
				) / 10,
			LK:
				Math.ceil(
					(ukupnoNadzemnoNeto /
						(spratType == 0 ? 1 : parkingMestaItems[1].LK)) *
						10
				) / 10,
		},
		{
			id: "3",
			sprat: 3,
			R:
				Math.ceil(
					(ukupnoNadzemnoNeto / (spratType == 0 ? 1 : parkingMestaItems[2].R)) *
						10
				) / 10,
			L:
				Math.ceil(
					(ukupnoNadzemnoNeto / (spratType == 0 ? 1 : parkingMestaItems[2].L)) *
						10
				) / 10,
			RK:
				Math.ceil(
					(ukupnoNadzemnoNeto /
						(spratType == 0 ? 1 : parkingMestaItems[2].RK)) *
						10
				) / 10,
			LK:
				Math.ceil(
					(ukupnoNadzemnoNeto /
						(spratType == 0 ? 1 : parkingMestaItems[2].LK)) *
						10
				) / 10,
		},
		{
			id: "0",
			sprat: 0,
			R: 0,
			L: 0,
			RK: 0,
			LK: 0,
		},
	])

	const [dodatniTrosakItems, setDodatniTrosakItems] = useState<any[]>([
		{
			id: "1",
			sprat: 1,
			R: 0,
			L: Math.ceil(cenaAutoLifta1 / ukupnoNadzemnoNeto),
			RK: Math.ceil(
				(cenaJedneKlackaliceZa2Auta * parkingMestaItems[0].RK) /
					ukupnoNadzemnoNeto
			),
			LK: Math.ceil(
				(cenaAutoLifta1 +
					cenaJedneKlackaliceZa2Auta * parkingMestaItems[0].LK) /
					ukupnoNadzemnoNeto
			),
		},
		{
			id: "2",
			sprat: 2,
			R: Math.ceil(cenaIzgradnjeJednePodzemneEtaze / ukupnoNadzemnoNeto),
			L: Math.ceil(
				(cenaAutoLifta2 + cenaIzgradnjeJednePodzemneEtaze) / ukupnoNadzemnoNeto
			),
			RK: Math.ceil(
				(cenaJedneKlackaliceZa2Auta * parkingMestaItems[1].RK +
					cenaIzgradnjeJednePodzemneEtaze) /
					ukupnoNadzemnoNeto
			),
			LK: Math.ceil(
				(cenaAutoLifta2 +
					cenaJedneKlackaliceZa2Auta * parkingMestaItems[1].LK +
					cenaIzgradnjeJednePodzemneEtaze) /
					ukupnoNadzemnoNeto
			),
		},
		{
			id: "3",
			sprat: 3,
			R: Math.ceil((cenaIzgradnjeJednePodzemneEtaze * 2) / ukupnoNadzemnoNeto),
			L: Math.ceil(
				(cenaAutoLifta3 + cenaIzgradnjeJednePodzemneEtaze * 2) /
					ukupnoNadzemnoNeto
			),
			RK: Math.ceil(
				(cenaJedneKlackaliceZa2Auta * parkingMestaItems[2].RK +
					cenaIzgradnjeJednePodzemneEtaze * 2) /
					ukupnoNadzemnoNeto
			),
			LK: Math.ceil(
				(cenaAutoLifta3 +
					cenaJedneKlackaliceZa2Auta * parkingMestaItems[2].LK +
					cenaIzgradnjeJednePodzemneEtaze * 2) /
					ukupnoNadzemnoNeto
			),
		},
		{
			id: "0",
			sprat: 0,
			R: 0,
			L: 0,
			RK: 0,
			LK: 0,
		},
	])

	const [sirinaParceleManja, setSirinaParceleManja] = useState(
		step2Items ? step2Items.sirinaParceleManja : 12
	)

	const [duzinaParceleManja, setDuzinaParceleManja] = useState(
		step2Items ? step2Items.duzinaParceleManja : 31
	)

	const checkSirinaAndDuzinaparcele = (komunikacija) => {
		if (
			(sirinaParcele < sirinaParceleManja ||
				pribliznaDuzinaParcele < duzinaParceleManja) &&
			(komunikacija == "R" || komunikacija == "RK")
		) {
			return false
		} else {
			return true
		}
	}

	const onPrev = async () => {
		if (currentClient?.id) {
			if (!checkSirinaAndDuzinaparcele(komunikacijaType)) {
				alert(
					"Nije moguće izabrati ovu komunikaciju zbog minimalne dužine ili širine parcele, izaberite drugu kombinaciju"
				)
			} else {
				const brutoPodzemnoUkupno = zauzetostPodzemno * +spratType
				const brutoNadzemnoUkupno =
					step1CalculatedData && step1CalculatedData[2]
						? step1CalculatedData[2][1]
						: undefined
				const brutoUkupno = brutoPodzemnoUkupno + brutoNadzemnoUkupno

				values.step2Items = {
					komunikacijaType,
					spratType,
					cenaLiftaKlackalice,
					brutoUkupno,
					zauzetostPodzemno,
					brutoNadzemnoUkupno,
					brojParkinga,
					sirinaParceleManja,
					duzinaParceleManja,
				}

				let id = canvasId

				id && id != ":id"
					? await CFCUseCase.update(canvasId, values)
					: (id = await onCreate(values, currentClient.id))
				// const query = createURLParams(formValues, useCustomTitle)
				const query = ""
				// eslint-disable-next-line
				history.push(
					`${routeVarReplacement(PrivateRoutes.PlanningStep1, [
						[":id", `${canvasId || id}`],
					])}?${query}`
				)
			}
		}
	}
	const onNext = async () => {
		if (currentClient?.id) {
			if (!checkSirinaAndDuzinaparcele(komunikacijaType)) {
				alert(
					"Nije moguće izabrati ovu komunikaciju zbog minimalne dužine ili širine parcele, izaberite drugu kombinaciju"
				)
			} else {
				const brutoPodzemnoUkupno = +zauzetostPodzemno * +spratType
				const brutoNadzemnoUkupno =
					step1CalculatedData && step1CalculatedData[2]
						? step1CalculatedData[2][1]
						: 0
				const brutoUkupno = +brutoPodzemnoUkupno + +brutoNadzemnoUkupno

				values.step2Items = {
					komunikacijaType,
					spratType,
					cenaLiftaKlackalice,
					brutoUkupno,
					zauzetostPodzemno,
					brutoNadzemnoUkupno,
					brojParkinga,
					sirinaParceleManja,
					duzinaParceleManja,
				}

				let id = canvasId

				id && id != ":id"
					? await CFCUseCase.update(canvasId, values)
					: (id = await onCreate(values, currentClient.id))
				// const query = createURLParams(formValues, useCustomTitle)
				const query = ""
				// eslint-disable-next-line
				history.push(
					`${routeVarReplacement(PrivateRoutes.PlanningStep3, [
						[":id", `${canvasId || id}`],
					])}?${query}`
				)
			}
		}
	}

	useEffect(() => {
		if (!useCustomTitle) {
			setFieldValue("canvasTitle", "")
		}
	}, [useCustomTitle, setFieldValue])

	const izracunajCenu = (
		komunikacija: KomunikacijaType,
		sprat: SpratType
	): number => {
		if (komunikacija === "R") {
			return 0
		} else if (komunikacija === "L" && sprat === "1") {
			return cenaAutoLifta1
		} else if (komunikacija === "L" && sprat === "2") {
			return cenaAutoLifta2
		} else if (komunikacija === "L" && sprat === "3") {
			return cenaAutoLifta3
		} else if (komunikacija === "RK" && sprat === "1") {
			return cenaKlackalica1
		} else if (komunikacija === "RK" && sprat === "2") {
			return cenaKlackalica2
		} else if (komunikacija === "RK" && sprat === "3") {
			return cenaKlackalica3
		} else if (komunikacija === "LK" && sprat === "1") {
			return cenaKlackalica1
		} else if (komunikacija === "LK" && sprat === "2") {
			return cenaKlackalica2
		} else if (komunikacija === "LK" && sprat === "3") {
			return cenaKlackalica3
		} else {
			return 0
		}
	}

	const vratiVrednostZaKomunikaciju = (spratnostData, komunikacijaType) => {
		let vrednost
		const { id, sprat, R, L, RK, LK } = spratnostData[0]

		switch (komunikacijaType) {
			case "R":
				vrednost = +R
				break
			case "L":
				vrednost = +L
				break
			case "RK":
				vrednost = +RK
				break
			case "LK":
				vrednost = +LK
				break
			default:
				vrednost = undefined
		}

		return vrednost
	}

	const [brojParkinga, setBrojParkinga] = useState(
		vratiVrednostZaKomunikaciju(parkingMestaItems, "R")
	)

	const onKomuniukacijaSelect = async (e) => {
		if (!checkSirinaAndDuzinaparcele(e.target.value)) {
			alert(
				"Nije moguće izabrati ovu komunikaciju zbog minimalne dužine ili širine parcele, izaberite drugu kombinaciju"
			)
		} else {
			setKomunikacijaType(e.target.value)
			setCenaLiftaKlackalice(izracunajCenu(e.target.value, spratType))
			setBrojParkinga(
				vratiVrednostZaKomunikaciju(parkingMestaItems, e.target.value)
			)
		}
	}

	const onSpratSelect = async (e) => {
		setSpratType(e.target.value)
		setCenaLiftaKlackalice(izracunajCenu(komunikacijaType, e.target.value))
	}

	const renderSingleItem = (item: any): ReactElement => {
		const { id, sprat, R, L, RK, LK } = item
		return (
			<TableRow key={id}>
				<TableCell>{sprat}</TableCell>
				<TableCell
					style={{
						backgroundColor:
							komunikacijaType === "R" && spratType == sprat
								? "red"
								: "inherit",
					}}
				>
					{!checkSirinaAndDuzinaparcele(komunikacijaType) ? "NA" : R}
				</TableCell>
				<TableCell
					style={{
						backgroundColor:
							komunikacijaType === "L" && spratType == sprat
								? "red"
								: "inherit",
					}}
				>
					{L}
				</TableCell>
				<TableCell
					style={{
						backgroundColor:
							komunikacijaType === "RK" && spratType == sprat
								? "red"
								: "inherit",
					}}
				>
					{!checkSirinaAndDuzinaparcele(komunikacijaType) ? "NA" : RK}
				</TableCell>
				<TableCell
					style={{
						backgroundColor:
							komunikacijaType === "LK" && spratType == sprat
								? "red"
								: "inherit",
					}}
				>
					{LK}
				</TableCell>
			</TableRow>
		)
	}

	return (
		<>
			<Box className={styles.box}>
				<Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onPrev}
				>
					Ulaz
				</Button>
				<Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onNext}
				>
					Troškovi
				</Button>
			</Box>
			<form onSubmit={handleSubmit} data-reactour="create-a-canvas">
				<PanelsTitle
					customTitle={"Wizard za gabarite podzemnih etaža"}
					useCustomTitle={true}
				/>
				<Spacer />
				<Spacer />
				<Box className={styles.box}>
					<Grid
						container
						spacing={10}
						// alignItems="center"
						// justify="center"
						// alignContent="center"
					>
						<Grid item xs={4}>
							<SectionTitle component="h3">
								Ukupni broj parking mesta
							</SectionTitle>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>Sprat</TableCell>
										<TableCell>R</TableCell>
										<TableCell>L</TableCell>
										<TableCell>R.K</TableCell>
										<TableCell>L.K</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{parkingMestaItems.map((item) => renderSingleItem(item))}
								</TableBody>
							</Table>
							<Spacer />
						</Grid>
						<Spacer />
						<Grid item xs={4}>
							<SectionTitle component="h3">
								Prosečna neto površina stana
							</SectionTitle>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>Sprat</TableCell>
										<TableCell>R</TableCell>
										<TableCell>L</TableCell>
										<TableCell>R.K</TableCell>
										<TableCell>L.K</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{povrsinaStanaItems.map((item) => renderSingleItem(item))}
								</TableBody>
							</Table>
							<Spacer />
						</Grid>
						<Spacer />
						<Grid item xs={4}>
							<SectionTitle component="h3">
								Dodatni trošak po prodajnom kvadratu
							</SectionTitle>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>Sprat</TableCell>
										<TableCell>R</TableCell>
										<TableCell>L</TableCell>
										<TableCell>R.K</TableCell>
										<TableCell>L.K</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{dodatniTrosakItems.map((item) => renderSingleItem(item))}
								</TableBody>
							</Table>
							<>
								Dodatni trošak po prodajnom kvadratu, u odnosu na najjeftiniju
								varijantu (R,1)
							</>

							<Spacer />
						</Grid>
					</Grid>
				</Box>

				<Box className={styles.box}>
					<Grid container spacing={10}>
						<Grid item xs={4}>
							<SectionTitle component="h3">
								Izbor komunikacija / spratnost
							</SectionTitle>
							<Grid container spacing={2}>
								<Grid item xs={5}>
									<KomunikacijaTypeSelect
										value={komunikacijaType}
										onChange={onKomuniukacijaSelect}
									/>
									<Spacer />
									<SpratTypeSelect value={spratType} onChange={onSpratSelect} />
								</Grid>
							</Grid>
							<Spacer />
						</Grid>

						<Grid item xs={4}>
							<SectionTitle component="h3">Uslov za male parcele</SectionTitle>
							<Table size="small">
								<TableBody>
									<TableRow key={11}>
										<TableCell>Ako je sirina parcele manja od</TableCell>
										<TableCell>
											<input
												type="number"
												value={sirinaParceleManja}
												onChange={(e) => setSirinaParceleManja(+e.target.value)}
											/>
										</TableCell>
									</TableRow>
									<TableRow key={22}>
										<TableCell>Ako je duzina parcele manja od</TableCell>
										<TableCell>
											<input
												type="number"
												value={duzinaParceleManja}
												onChange={(e) => setDuzinaParceleManja(+e.target.value)}
											/>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</Grid>
						<Grid item xs={4}>
							<SectionTitle component="h3">Rezultati wizarda</SectionTitle>
							<Table size="small">
								<TableBody>
									<TableRow key={1}>
										<TableCell>Bruto podzemno jedna etaža</TableCell>
										<TableCell>{formatNumberZero(zauzetostPodzemno)}</TableCell>
									</TableRow>
									<TableRow key={2}>
										<TableCell>Cena izgradnje jedne podzemne etaze</TableCell>
										<TableCell>
											{formatNumberZero(
												trosakPoBrutoPovrsiniPodzemno * zauzetostPodzemno
											)}
										</TableCell>
									</TableRow>
									<TableRow key={3}>
										<TableCell>Trošak za autolift ili klackalice </TableCell>
										<TableCell>
											{formatNumberZero(
												izracunajCenu(komunikacijaType, spratType)
											)}
										</TableCell>
									</TableRow>
									<TableRow key={4}>
										<TableCell
											style={{
												fontWeight: "bold",
											}}
										>
											Ukupno koštanje podzemnih etaža
										</TableCell>
										<TableCell
											style={{
												fontWeight: "bold",
											}}
										>
											{formatNumberZero(
												+spratType *
													(trosakPoBrutoPovrsiniPodzemno * zauzetostPodzemno) +
													izracunajCenu(komunikacijaType, spratType)
											)}
										</TableCell>
									</TableRow>
									<TableRow key={5}>
										<TableCell
											style={{
												fontWeight: "bold",
											}}
										>
											Bruto podzemno ukupno
										</TableCell>
										<TableCell
											style={{
												fontWeight: "bold",
											}}
										>
											{formatNumberZero(+zauzetostPodzemno * +spratType)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											style={{
												fontWeight: "bold",
											}}
										>
											Bruto ukupno cela zgrada
										</TableCell>
										<TableCell
											style={{
												fontWeight: "bold",
											}}
										>
											{formatNumberZero(
												step1CalculatedData && step1CalculatedData[2]
													? +step1CalculatedData[2][1] +
															+zauzetostPodzemno * +spratType
													: +zauzetostPodzemno * +spratType
											)}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</Grid>
						<Spacer />
					</Grid>
				</Box>
			</form>
		</>
	)
}
